import SubmenuItemList from './SubmenuItemList';
import { SubmenuItemListProps, SubmenuItemListValueProps } from './types';

export type { SubmenuItemListProps, SubmenuItemListValueProps };
export default SubmenuItemList;
